import { render } from "./legoFormItem.vue?vue&type=template&id=7561362a"
import script from "./legoFormItem.vue?vue&type=script&lang=js"
export * from "./legoFormItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/boxes/legoFormBox/legoFormItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7561362a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7561362a', __exports__)) {
    api.reload('7561362a', __exports__)
  }
  
  module.hot.accept("./legoFormItem.vue?vue&type=template&id=7561362a", () => {
    api.rerender('7561362a', render)
  })

}


export default __exports__